module.exports = __webpack_public_path__ + "static/media/tiendada-pattern.10d08f83.svg";